

import img7 from '../images/blog/blog-07.jpg'
import img8 from '../images/blog/blog-08.jpg'
import img9 from '../images/blog/blog-09.jpg'
import img10 from '../images/blog/blog-10.jpg'
import img11 from '../images/blog/blog-11.jpg'
import img12 from '../images/blog/blog-12.jpg'
import img13 from '../images/blog/blog-13.jpg'
import img14 from '../images/blog/blog-14.jpg'
import img15 from '../images/blog/blog-15.jpg'

const dataBlog = [
    {
        img: img7,
        videoEmbed: 'https://player.vimeo.com/video/340678980?badge=0&autopause=0&player_id=0&app_id=58479',
        mediaType: 'video',
        category: 'Neuroteach Global',
        title: 'Mind, Brain, Education MBE platform video promo.'
    },
    {
        img: img8,
        videoEmbed: 'https://player.vimeo.com/video/878406694?badge=0&autopause=0&player_id=0&app_id=58479',
        mediaType: 'video',
        category: 'Festival of Education',
        title: 'Festival of Education, USA 2023 recap video'
    },
    {
        img: img9,
        videoEmbed: 'https://player.vimeo.com/video/440430611?badge=0&autopause=0&player_id=0&app_id=58479',
        mediaType: 'video',
        category: 'Connect ED',
        title: 'Families access to education, Department of Education'
    },
    {
        img: img10,
        videoEmbed: 'https://player.vimeo.com/video/1044450189?badge=0&autopause=0&player_id=0&app_id=58479',
        mediaType: 'video',
        category: 'DC PCSB',
        title: 'Why a Charter VLog series - Briya PCS'
    },
    {
        img: img11,
        videoEmbed: 'https://player.vimeo.com/video/393469693?badge=0&autopause=0&player_id=0&app_id=58479',
        mediaType: 'video',
        category: 'D!LAB',
        title: 'The D!LAB is the design thinking process'
    },
    {
        img: img12,
        videoEmbed: 'https://player.vimeo.com/video/259892718?badge=0&autopause=0&player_id=0&app_id=58479',
        mediaType: 'video',
        category: 'CTTL Academy',
        title: 'Center for Transformative Teaching and Learning summer 2018 academy video'
    },
    {
        img: img13,
        videoEmbed: 'https://player.vimeo.com/video/137151286?badge=0&autopause=0&player_id=0&app_id=58479',
        mediaType: 'video',
        category: 'Concord Hill School',
        title: 'Concord Hill School 50th Aniversary video'
    },
    {
        img: img14,
        videoEmbed: 'https://player.vimeo.com/video/859153477?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        mediaType: 'video',
        category: 'EMURGO Global',
        title: 'EMURGO Academy webinar intro pre-roll '
    },
    {
        img: img15,
        videoEmbed: 'https://player.vimeo.com/video/761570477?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        mediaType: 'video',
        category: 'DC PCSB',
        title: 'Teacher of the year 2022 video profile'
    },
    {
        img: img7,
        videoEmbed: 'https://player.vimeo.com/video/513536608?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        mediaType: 'video',
        category: 'Neurotech Global',
        title: 'Website promotional video'
    },
    {
        img: img8,
        videoEmbed: 'https://player.vimeo.com/video/486444941?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        mediaType: 'video',
        category: 'Worldgate Metro Plaza',
        title: 'Commercial realestate video walkthrough'
    },
    {
        img: img9,
        videoEmbed: 'https://player.vimeo.com/video/555347970?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        mediaType: 'video',
        category: 'Digital Pioneers PCS',
        title: 'Graduation video'
    },
    {
        img: img10,
        videoEmbed: 'https://player.vimeo.com/video/831687209?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        mediaType: 'video',
        category: 'DC PCSB',
        title: 'DC PCSB Communuty Engagement video'
    },
    {
        img: img11,
        videoEmbed: 'https://player.vimeo.com/video/648826377?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        mediaType: 'video',
        category: 'OSSE',
        title: 'DC Teacher Thank You Video.'
    },
    {
        img: img12,
        videoEmbed: 'https://player.vimeo.com/video/738383369?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
        mediaType: 'video',
        category: 'DC PCSB',
        title: 'DC PCSB 2022 Graduation Message'
    },
]

export default dataBlog;